module.exports = __webpack_public_path__ + "static/media/Resume_Online.12205c27.pdf";